export const inventoryTabs = [
  {
    label: "Zero Stocks",
    value: "zeroStocks",
  },
  {
    label: "Near Expiry Stocks",
    value: "nearExpiryStocks",
  },
  {
    label: "Low Stocks",
    value: "lowStocks",
  },
  {
    label: "Dead Stocks",
    value: "deadStocks",
  },
  {
    label: "Non Moving Stocks",
    value: "nonMovingStocks",
  },
];

export const salesTabs = [
  {
    label: "Billing",
    value: "billing",
  },
  {
    label: "Returns",
    value: "returns",
  },
];
